import {createAction} from '@reduxjs/toolkit';
import {NavigateFunction} from 'react-router';
import {CreatePubDTO, GetPubsDTO} from 'typescript/dto/pubsDto';
import {withPayloadType} from 'typescript/types/PayloadType';

const pubSliceNamespace = 'pubs';

const getPubsACS = createAction(`${pubSliceNamespace}/getPubsACS`, withPayloadType<GetPubsDTO>());

const createPubACS = createAction(
  `${pubSliceNamespace}/createPubACS`,

  withPayloadType<{dto: CreatePubDTO; navigate?: NavigateFunction}>(),
);

export {getPubsACS, createPubACS};
